(function(angular){
	'use strict';
	
	var amountSelectObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			amount: '=?',
			amountOptions: '<?',
			input: '<?',
			min: '<?',
			max: '<?',
			name: '<?'
		},
		controller: [
			'$filter',
			'$scope',
			'$timeout',
			'$window',
			'mixpanelFactory',
			AmountSelectFunction
		],
		controllerAs: 'amountSelect'
	};
	
	angular
		.module('amountSelectModule')
		.component('amountSelect', amountSelectObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/amount-select/amount-select.html';
	}
	
	function AmountSelectFunction(
		$filter,
		$scope,
		$timeout,
		$window,
		mixpanelFactory
	) {
		var amountSelect = this;

		function getLocalAmountOptions(amountOptions) {
			var localAmountOptions = amountOptions;
			
			if(angular.isDefined(amountSelect.amount) && angular.isDefined(amountSelect.amount.value) && amountSelect.amount.value !== 0) {
				var customAmount = {
					value: amountSelect.amount.value,
					label: $filter('currency')(amountSelect.amount.value, '$', 0),
					sortIndex: amountSelect.amount.value
				};

				localAmountOptions.push(customAmount);
			}

			localAmountOptions = $filter('unique')(localAmountOptions, 'value');
			localAmountOptions = $filter('orderBy')(localAmountOptions, 'sortIndex');

			return localAmountOptions;
		}

		amountSelect.updateCustomAmount = function(input) {
			amountSelect.amount = {
				value: input
			};
		};

		amountSelect.updateSelection = function(selection) {
			var customAmountSelected = selection.value === 'other';

			if(customAmountSelected) {
				amountSelect.showCustomAmountInput = true;
				mixpanelFactory.track('Custom Additional Investment Amount Field Shown');
				$timeout(function() {
					var customAmountInput = angular.element($window.document.getElementById(amountSelect.name + '-custom-amount-input'))[0];
					customAmountInput.focus();
					if(angular.isDefined(amountSelect.input)) {
						amountSelect.input.$setTouched();
					}
				});
			}
		};

		amountSelect.$onInit = function() {
			amountSelect.name = amountSelect.name || 'amount';
		};

		amountSelect.$onChanges = function() {
			if(angular.isDefined(amountSelect.amountOptions)) {
				amountSelect.amountOptions = getLocalAmountOptions(angular.copy(amountSelect.amountOptions));
			}
		};

		$scope.$on('amountSelect:setCustomAmountToUpgradeAmount', function(evt, amount) {
			amountSelect.updateSelection($filter('filter')(amountSelect.amountOptions, {'value': 'other'}, true)[0]);
			amountSelect.customAmount = amount;
			amountSelect.updateCustomAmount(amount);
		});
	}
})(window.angular);